import { render, staticRenderFns } from "./value-card-view.vue?vue&type=template&id=ed88128a&scoped=true&"
import script from "./value-card-view.vue?vue&type=script&lang=ts&"
export * from "./value-card-view.vue?vue&type=script&lang=ts&"
import style0 from "./value-card-view.vue?vue&type=style&index=0&id=ed88128a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed88128a",
  null
  
)

export default component.exports